<ng-lottie
  [options]="options()"
  (animationCreated)="animationCreated($event)"
  containerClass="lottie-container"
></ng-lottie>
